<template>     
    <div class="bg-black py-4 flex justify-center items-center lg:w-full lg:py-2">       
        <div class="flex items-center justify-center sm:ml-0">           
            <h1 class="font-krona text-white text-[12px] lg:text-[20px] md:text-[18px]">             
                © 2025 CopyRight | Design by <a href="https://www.facebook.com/profile.php?id=61560331987437" target="_blank">Web services</a>           
            </h1>      
        </div>     
    </div>
</template>